module.exports = __webpack_public_path__ + "static/media/openweathermap.3d5e5b3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/openweathermap.png
// module id = 56
// module chunks = 0